import { Component, OnInit } from '@angular/core';
import { style } from '@angular/animations';
import mixitup from 'mixitup';
declare const func3: any;
declare var $:any;
declare const card: any;
declare const search:any;
declare const v_search:any;
declare const animatedselect:any;



@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})
export class PurchaseComponent implements OnInit {


 p:any;
 modal:any;
  warrantyprice:any;
  
  filters_value:any=[];
  loader:boolean;
  
  constructor() { }

  isfilter(){

    $('.purchase_cards').css('display','none');
    $('#filtersblock').css('display','block');
    $('.applyfilter').css('display','none');
    $('.paginate').css('display','block');
    
  }

  removefilter(){
    $('.filterdrop').removeClass('active');
    $('.filterdrop').find('.dropdown-menu').slideUp(300);
    $('.purchase_cards').css('display','block');
    $('.applyfilter').css('display','block');
    $('#filtersblock').css('display','none');
    $('.paginate').css('display','none');
  }

  ngOnInit(): void {
   var filters=[
     {"type":"Raw","price":"500","category":"Data","classification":"Sensitive"},
     {"type":"Raw","price":"600","category":"Data","classification":"Confidential"},
     {"type":"Raw","price":"1000","category":"Algorithm","classification":"Sensitive"},
     {"type":"Raw","price":"1200","category":"Algorithm","classification":"Public"},
     {"type":"Transformed","price":"500","category":"Data","classification":"Sensitive"},
     {"type":"Transformed","price":"600","category":"Data","classification":"Confidential"},
     {"type":"Transformed","price":"1000","category":"Algorithm","classification":"Sensitive"},
     {"type":"Transformed","price":"1200","category":"Algorithm","classification":"Public"},
     {"type":"Raw","price":"1000","category":"Engine","classification":"Sensitive"},
     {"type":"Raw","price":"1200","category":"Solution","classification":"Public"},
     {"type":"Transformed","price":"500","category":"Engine","classification":"Sensitive"},
     {"type":"Transformed","price":"600","category":"Solution","classification":"Confidential"},
 ];
    func3();
    card();
    search();
    v_search();
    animatedselect();
   var warrantytimeprice=this;
    warrantytimeprice.warrantyprice=18;
   if ($(window).width() > 767) {
    $(document).ready(function(){
          $('.purchase').addClass('active');
          $('.purchase a').css('color','#fff');
          $('.purchase img').attr('src','./assets/image/icon/Purchase.png');

          
                 });
        $(".header-title p").text('Purchase');
    }   
      $(document).ready(function(){
      $(".warrantytime").change();
       $(".warrantytime").change(function(){
          var months=$(this). children("option:selected"). val();
          if(months=='6')
          {
           warrantytimeprice.warrantyprice=18;
          }
          if(months=='12')
          {
           warrantytimeprice.warrantyprice=24;
          }
          if(months=='18')
          {
           warrantytimeprice.warrantyprice=36;
          }
          if(months=='24')
          {
           warrantytimeprice.warrantyprice=48;
          }

       });

       $(function(){
         $('.click-me').blur();
       });
        $(".domain_name_filter li").click(function(){
          PurchaseComponent.prototype.isfilter();
          var domain_filter=new Array();
          var value=$(this).attr("value");
          for(var i=0;i<filters.length;i++)
          {
            if(filters[i]['category']==value)
            {
              domain_filter.push(filters[i]);
            }
          }
          warrantytimeprice.filters_value=domain_filter;
        })
       $(".filter").change(function(e){
           e.preventDefault();
           PurchaseComponent.prototype.isfilter();
           var type=new Array();
           var price=new Array();
           var category=new Array();
           var classification=new Array();
           var filters_type=new Array();
           var filters_price=new Array();
           var filters_category=new Array();
           var filters_classification=new Array();
           warrantytimeprice.filters_value=filters;
           warrantytimeprice.loader=true;
        $('input[name="type"]:checked').each(function(){
           type.push($(this).val());
        });
        if(type.length>0){
         for(var i=0;i<type.length;i++)
           {
           for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(type[i]==warrantytimeprice.filters_value[j]['type'])
              {
               filters_type.push(warrantytimeprice.filters_value[j]);
              }
            }
           } 
             warrantytimeprice.filters_value=filters_type;
           }
        $('input[name="price"]:checked').each(function(){
           price.push($(this).val());
        });
        if(price.length>0){
         for(var i=0;i<price.length;i++)
           {
           if(0<price[i] && price[i]<500)
           {
            for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(0<warrantytimeprice.filters_value[j]['price'] && warrantytimeprice.filters_value[j]['price']<500)
              {
               filters_price.push(warrantytimeprice.filters_value[j]);
              }
            }
           }
           if(500<=price[i] && price[i]<1000)
           {
            for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(500<=warrantytimeprice.filters_value[j]['price'] && warrantytimeprice.filters_value[j]['price']<1000)
              {
               filters_price.push(warrantytimeprice.filters_value[j]);
              }
            }
           }
           if(1000<=price[i])
           {
            for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(1000<=warrantytimeprice.filters_value[j]['price'])
              {
               filters_price.push(warrantytimeprice.filters_value[j]);
              }
            }
           }
           } 
           warrantytimeprice.filters_value=filters_price;
           }
         $('input[name="category"]:checked').each(function(){
           category.push($(this).val());
        });
        if(category.length>0){
         for(var i=0;i<category.length;i++)
           {
           for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(category[i]==warrantytimeprice.filters_value[j]['category'])
              {
               filters_category.push(warrantytimeprice.filters_value[j]);
              }
            }
           } 
           warrantytimeprice.filters_value=filters_category;
           }
            $('input[name="classification"]:checked').each(function(){
           classification.push($(this).val());
        });
        if(classification.length>0){
         for(var i=0;i<classification.length;i++)
           {
           for(var j=0;j<warrantytimeprice.filters_value.length;j++){
             if(classification[i]==warrantytimeprice.filters_value[j]['classification'])
              {
               filters_classification.push(warrantytimeprice.filters_value[j]);
              }
            }
           } 
           warrantytimeprice.filters_value=filters_classification;
           }
           warrantytimeprice.loader=false;
       })
       })

  }

  istype=true;
  isprice=true;
  iscategory=true;
  isclassify=true;

 
  type(){
    this.istype=!this.istype;
  }

  price(){
    this.isprice=!this.isprice;
  }

  category(){
    this.iscategory=!this.iscategory;
  }

  classify(){
    this.isclassify=!this.isclassify;
  }

  onClick(event){
     $(".detailmodal").modal('show');
   }

   onClick1(event){
    $(".detailmodal_2").modal('show');
  }

  onClick2(event){
    $(".detailmodal_3").modal('show');
  }

  onClick3(event){
    $(".detailmodal_4").modal('show');
  }


  onClick4(event){
    $(".detailmodal_5").modal('show');
  }

  onClick5(event){
   $(".detailmodal_6").modal('show');
 }

 onClick6(event){
   $(".detailmodal_7").modal('show');
 }

 onClick7(event){
   $(".detailmodal_8").modal('show');
 }

 onClick8(event){
  $(".detailmodal_9").modal('show');
}


onClick9(event){
  $(".detailmodal_10").modal('show');
}

onClick10(event){
 $(".detailmodal_11").modal('show');
}

onClick11(event){
 $(".detailmodal_12").modal('show');
}

onClick12(event){
 $(".detailmodal_13").modal('show');
}


  hovercard($event){
    $(".info_heading").css('transition','0.65s all'); 
    $(".inner-div").css('transition', '0.65s all');
   }
     hovercard2($event){
     $(".info_heading").css('transition','0.65s all');
     $(".inner-div").css('transition', '0.65s all');
     }

     purchasehovercard($event){
      $(".card-img-top").css('transition','0.35s all'); 
      $(".card-category").css('transition', '0.35s all');
     }
       purchasehovercard2($event){
       $(".card-img-top").css('transition','0.35s all');
       $(".card-category").css('transition', '0.35s all');
       }

}
